import { makeRoute } from "../../libs/router";
import Index from './index';



export default [
  makeRoute('', Index),
]
